import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getCompositeInputTestIds = createTestIds('composite-input', [
  'control',
  ...elements
] as const);
